import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/Centerone/index"),
    meta: {
      title: "Centerone",
      // metaInfo: [
      //   {
      //     name: "keywords",
      //     content: "",
      //   },
      //   {
      //     name: "description",
      //     content: "",
      //   },
      //   { name: "viewport", content: "width=device-width" },
      //   { property: "og:type", content: "website" },
      //   { property: "og:title", content: "화성시 화상영어" },
      //   {
      //     property: "og:description",
      //     content: "",
      //   },
      //   { property: "og:url", content: "https://www.hscarrot.co.kr" },
      //   {
      //     property: "og:image",
      //     content: "https://www.hscarrot.co.kr/img/hscarrot.1df592b3.png",
      //   },
      // ],
    },
  },
];
const centerone = new VueRouter({
  mode: "history",
  routes,
});

centerone.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default centerone;
